import {useState, useEffect} from 'react';
// import './style.css';
import React from 'react';
import Promotion from './components/Promotion/Promotion.js';
import Loader from './components/UI/Loader.js';
import Error from './components/UI/Error.js';
import {useTranslation} from 'react-i18next';

const App = () => {

	const [promotionSettings, setpromotionSettings] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const {i18n} = useTranslation();


	useEffect(() => {
		let fetchURL = "";
		//i18n.changeLanguage((window.market).toLowerCase());
		// change language setting logic to the pl-pl, nl-nl format and bind to the pathprefix
		i18n.changeLanguage((!window.pathPrefix || window.pathPrefix === "") ? (window.market).toLowerCase() : window.pathPrefix.replace(/^\/+|\/+$/g, ''));

		window.dataLayer = window.dataLayer || [];

		if (window.pathPrefix !== "") {
			fetchURL = `${process.env.REACT_APP_BASE_URL}/${window.pathPrefix}/api/joypepsico-app/v1/promotion/${window.promotionID}/frontend`;
		} else {
			fetchURL = `${process.env.REACT_APP_BASE_URL}/api/joypepsico-app/v1/promotion/${window.promotionID}/frontend`;
		}

		const fetchPromotionData = async () => {
			try {
				const response = await fetch(fetchURL);
				if (!response.ok) {
					throw new Error('Network Error');
				}
				const jsonData = await response.json();

				setpromotionSettings(jsonData.result);

				document.title = jsonData.result.promotion_page.promotion_title;
				// i18n.changeLanguage((jsonData.result.promotion_page.market).toLowerCase());
			} catch (error) {
				setError(error);
			} finally {
				setLoading(false);
			}
		};
		fetchPromotionData();

	}, [i18n]);

	if (loading) {
		return <Loader/>;
	}

	if (error) {
		return <Error/>;
	}

	return (
		<Promotion promotionSettings={promotionSettings}/>
	);
}

export default App;
